import { Controller } from 'stimulus';

export default class FeaturedEventsController extends Controller {
  static targets = [
    'imageContainer',
    'carousel',
    'main',
    'mainLink',
    'scrollContainer',
  ];

  connect() {
    this.totalFetched = 3;
    this.allFetched = false;
    this.isLoading = false;
  }

  async selectEvent(e) {
    e.preventDefault();
    if (this.isLoading || e.currentTarget.classList.contains('selected'))
      return;

    const side = e.currentTarget.dataset.side;

    this._makeSelection(e.currentTarget);
    this._updateMainEvent(e.currentTarget);
    this._scrollSelectedEventIntoView();

    if (this.allFetched || side === 'center') return;

    const leftMostEvent = document.querySelector('[data-side="left"]');
    const rightElements = document.querySelectorAll('[data-side="right"]');
    const rightMostEvent = rightElements[rightElements.length - 1];
    const leftMostSelected = leftMostEvent.classList.contains('selected');
    const rightMostSelected = rightMostEvent.classList.contains('selected');

    if (!(leftMostSelected || rightMostSelected)) return;

    const eventHtml = await this._fetchNextEvent(side);
    if (!eventHtml) return;

    if (side === 'left' && leftMostSelected) {
      const previousScrollLeft = this.scrollContainerTarget.scrollLeft;
      const previousScrollWidth = this.scrollContainerTarget.scrollWidth;

      this._appendEvent(eventHtml, 'left');

      const newScrollWidth = this.scrollContainerTarget.scrollWidth;
      const widthDiff = newScrollWidth - previousScrollWidth;

      this.scrollContainerTarget.scrollLeft = previousScrollLeft + widthDiff;
    } else if (side === 'right' && rightMostSelected) {
      this._appendEvent(eventHtml, 'right');
    }

    this._scrollSelectedEventIntoView();
  }

  _appendEvent(eventHtml, side) {
    const template = document.createElement('template');
    template.innerHTML = eventHtml.trim();

    const newElement = template.content.firstElementChild;
    if (!newElement) return;

    switch (side) {
      case 'left':
        this.carouselTarget.prepend(newElement);
        break;
      case 'right':
        this.carouselTarget.append(newElement);
        break;
      default:
        return;
    }
  }

  async _fetchNextEvent(side) {
    this.isLoading = true;

    const res = await fetch(
      `/featured_events?offset=${this.totalFetched}&limit=${1}&side=${side}`,
      {
        headers: { Accept: 'application/json' },
      },
    );

    this.isLoading = false;

    if (res.status === 204) {
      this.allFetched = true;
      return;
    }

    const data = await res.json();
    this.totalFetched += 1;
    return data.html;
  }

  _makeSelection(selection) {
    this.imageContainerTargets.forEach((imageContainer) => {
      imageContainer.classList.remove('selected');
    });

    selection.classList.add('selected');
  }

  _scrollSelectedEventIntoView = () => {
    const selectedEvent = document.querySelector('.selected');

    selectedEvent.scrollIntoView({
      block: 'nearest',
      inline: 'center',
      behavior: 'smooth',
    });
  };

  _updateMainEvent = (selection) => {
    this.mainTarget.src = selection.dataset.eventImageUrl;
    this.mainLinkTarget.href = selection.dataset.eventUrl;
  };
}
